import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ChartComponent} from "ng-apexcharts";
import {ChannelDefinition} from "../../../../model/channels.model";
import {DecisionsService} from "../../decisions.service";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {ChartOptions} from "../../../../app.module";

@Component({
  selector: 'admin-decisions-model-expectation',
  templateUrl: './expectation.component.html',
  styleUrls: ['./expectation.component.css']
})
export class ExpectationComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;

  @Input() channel: ChannelDefinition = new ChannelDefinition();

  public engineChart: Partial<ChartOptions>
  public decisionChart: Partial<ChartOptions>

  public commonOptions: Partial<ChartOptions> = {
    chart: {
      height: 250,
      zoom: {
        enabled: false
      }
    },
    fill: {
    },
    colors: ["#0066ff", "#ff0000", "#0066ff", "#ff0000"],
    xaxis: {
      type: 'numeric',
      labels: {
        formatter: function (value) {
          let temp = +value
          return temp.toFixed(3);
        }
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return "";
        }
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: [5, 5, 3, 3],
      curve: "smooth",
      dashArray: [0, 0, 4, 4]
    },
    toolbar: {
      tools: {
        selection: false
      }
    },
    grid: {
      show: true,
      strokeDashArray: 1,
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: false
        }
      },
      column: {
        colors: ['#f8f8f8', 'transparent'],
        opacity: 0.5
      }
    }
  };

  constructor(
    private service: DecisionsService,
    private viewManager: ViewManagerService
  ) {
    this.engineChart = {
      series: [],
      title: {
        text: "engine contour"
      }
    };
    this.decisionChart = {
      series: [],
      title: {
        text: "decision contour"
      }
    };
  }

  ngOnInit(): void {
    this.service.expectation(this.channel.config!, "engine")
      .pipe()
      .subscribe({
        next: (result) => {
          this.engineChart.series = [
            {name: "latest(true|+)", data: this.service.buildDistribution(result['latest'].expectations!.truePositive!), type: 'line'},
            {name: "latest(false|+)", data: this.service.buildDistribution(result['latest'].expectations!.falsePositive!), type: 'line'},
            {name: "previous(true|+)", data: this.service.buildDistribution(result['previous'].expectations!.truePositive!), type: 'line'},
            {name: "previous(false|+)", data: this.service.buildDistribution(result['previous'].expectations!.falsePositive!), type: 'line'},
          ];
        },
        error: error => {
          console.log(error);
        }
      });

    this.service.expectation(this.channel.config!, "decision")
      .pipe()
      .subscribe({
        next: (result) => {
          this.decisionChart.series = [
            {name: "latest(true|+)", data: this.service.buildDistribution(result['latest'].expectations!.truePositive!), type: 'line'},
            {name: "latest(false|+)", data: this.service.buildDistribution(result['latest'].expectations!.falsePositive!), type: 'line'},
            {name: "previous(true|+)", data: this.service.buildDistribution(result['previous'].expectations!.truePositive!), type: 'line'},
            {name: "previous(false|+)", data: this.service.buildDistribution(result['previous'].expectations!.falsePositive!), type: 'line'},
          ];
        },
        error: error => {
          console.log(error);
        }
      });
  }
}

